// extracted by mini-css-extract-plugin
module.exports = {"light":"style_light__35lU6","wrapper":"style_wrapper__3WNDo","nav":"style_nav__1epgq","navShadow":"style_navShadow__2acdg"};